﻿export class SimpleDialog {
    private _titleText: string = 'Message';
    private _contentText: string = 'This page says hello :)';

    public _destroyed: boolean = false;
    private modal: JQuery = null;
    private modalContent: JQuery = null;
    private modalHeader: JQuery = null;
    private modalCloseButton: JQuery = null;
    private modalHeaderText: JQuery = null;
    private modalBody: JQuery = null;
    private modalFooter: JQuery = null;
    private modalFooterDismissButton: JQuery = null;
    private modalFooterConfirmButton: JQuery = null;

    constructor(title: string, content: string, private isBodyHtml: boolean = false, isConfirmDialog: boolean = false, confirmCallback: (sd: SimpleDialog) => any = null) {
        this._titleText = title;
        this._contentText = content;

        this.modal = $('<div class="modal fade SimpleDialog--modal"></div>').appendTo('body');
        this.modalContent = $('<div class="modal-content"></div>').appendTo($('<div class="modal-dialog"></div>').appendTo(this.modal));

        this.modalHeader = $('<div class="modal-header"></div>').appendTo(this.modalContent);
        this.modalCloseButton = $('<button type="button" class="close" data-dismiss="modal" aria-hidden="true">&times;</button>').appendTo(this.modalHeader);
        this.modalHeaderText = $('<h4 class="modal-title"></h4>').appendTo(this.modalHeader);

        if (this._titleText !== null) {
            //this.modalHeaderText.text(this._titleText);
            this.setTitle(this._titleText);
        }

        this.modalBody = $('<div class="modal-body"></div>').appendTo(this.modalContent);

        if (this._contentText !== null) {
            if (this.isBodyHtml) {
                this.modalBody.html(this._contentText);
            } else {
                this.modalBody.append($('<p></p>').text(this._contentText));
            }
        }

        this.modalFooter = $('<div class="modal-footer"></div>').appendTo(this.modalContent);
        if (isConfirmDialog) {
            this.modalFooterConfirmButton = $('<button type="button" class="btn btn-success">OK</button>').appendTo(this.modalFooter);
            let _this: SimpleDialog = this;
            this.modalFooterConfirmButton.on("click", e => {
                if (confirmCallback) {
                    confirmCallback(_this);
                } else {
                    console.warn("NO CALLBACK DEFINED FOR THE CONFIRM DIALOG!", _this);
                    alert("Error: no action defined for this confirmation.");
                    _this.hide();
                }
            });
            this.modalFooterDismissButton = $('<button type="button" class="btn btn-default" data-dismiss="modal">Cancel</button>').appendTo(this.modalFooter);
        } else {
            this.modalFooterDismissButton = $('<button type="button" class="btn btn-default" data-dismiss="modal">OK</button>').appendTo(this.modalFooter);
        }

        this.modal.on("hidden.bs.modal", e => {
            this.destroy();
        });
    };

    private destroy(): void {
        if (this.modal) {
            this._destroyed = true;
            this.modal.remove();
            this.modal = null;
            this.modalContent = null;
            this.modalHeader = null;
            this.modalCloseButton = null;
            this.modalHeaderText = null;
            this.modalBody = null;
            this.modalFooter = null;
            this.modalFooterDismissButton = null;
            this.modalFooterConfirmButton = null;
        }
    }

    public show(): void {
        this.modal.modal({
            backdrop: 'static',
            keyboard: false,
            show: true
        });
    }

    public hide(): void {
        this.modal.modal('hide');
    }

    public setTitle(title: string = ""): void {
        this.modalHeaderText.text(title); //: NB: not escaping string here as we're using the .text method from JQuery.
    }

    public getModal(): JQuery {
        return this.modal;
    }

    public getBody(): JQuery {
        return this.modalBody;
    }

    public getFooter(): JQuery {
        return this.modalFooter;
    }

    public getDismissButton(): JQuery {
        return this.modalFooterDismissButton;
    }
}